import { Grid, Typography } from '@mui/material';
import styles from '../Information/Information.module.scss';
import { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { apiRequest, catchErrorMessageHandler } from '../../infrastructure/backendService';
import ToastError from '../common/toast/toastError';
import apiPath from '../../config/apiPaths.json';
import { isNil,isEmpty, isNull, isUndefined } from 'lodash';
import ErrorPopup from '../common/ErrorPopup';
import constants from "../../config/constants.json";

const Newsletter = () => {
    const [isOpen, setIsOpen] = useState<boolean>(false);
    const [itemsData, setItemsData] = useState<any[]>([]);
    useEffect(() => {
        apiRequest({
            method: 'GET',
            endpoint: apiPath.newsLetterPaschimaVani,
        })
            .then((res) => {
                setItemsData(res.data.content);
            })
            .catch((err) => {
                console.log(err);
                toast.custom(<ErrorPopup showMessage={catchErrorMessageHandler(err)} isOpen={isOpen} setIsOpen={setIsOpen} />, {
                    duration: constants.TOAST_POPUP_DURATION,
                  });
            });
    }, []);

    const handleFileClick = (fileUrl: string) => {
        console.log(fileUrl,"fileurl")
        // Implement the action you want to take when a file is clicked
        if(!isNil(fileUrl) || !isEmpty(fileUrl) || !isNull(fileUrl) || !isUndefined(fileUrl)) {
  
           window.open(`${fileUrl}`, "_blank");
           // You can use window.open(fileUrl) to open the URL in a new tab/window
        }
        
     };

    return (
        <>
            <div className={styles.Newsletter}>
                <Grid>
                    <Typography className={styles.typoGraphyHeading}>
                        Newsletter
                    </Typography>
                </Grid>
                <div>
                    <Grid sx={{ marginTop: "20px" }} className={styles.cardContainer}>
                        <div className={styles.tableWrapper}>
                        <table className={styles.tableContainer}>
                            <thead>
                                <tr className={styles.headerTableRow}>
                                    <th className={styles.tableHorizontal}>Title</th>
                                    <th className={styles.tableHorizontal}>Date & Time</th>
                                    <th className={styles.tableHorizontal}>File Size</th>
                                    <th className={styles.tableHorizontal}>Description</th>
                                </tr>
                            </thead>
                            <tbody>
                                {itemsData.map((item, index) => (
                                    <tr className={styles.tableRow} key={index}>
                                        <td className={`${styles.tableDiagonal} ${styles.documentName}`} onClick={() => { handleFileClick(item.filepath); }}>
                                            
                                            {item.title}
                                        </td>
                                        <td className={styles.tableDiagonal}>
                                            {item.uploadedOn}
                                        </td>
                                        <td className={styles.tableDiagonal}>
                                            {item.sizeOfFile ? item.sizeOfFile : "-"}
                                        </td>
                                        <td className={styles.tableDiagonal}>
                                            {item.description}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                    </Grid>
                </div>
            </div>
        </>
    )
}
export default Newsletter;
